<template>
  <div class="parking-history-contract-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
            <div class="ibox-tools">
              <el-button type="text" @click="toggleMoreCondition">
                {{ listParkingSpaceInfo.moreCondition ? "隐藏" : "更多" }}
              </el-button>
            </div>
          </div>
          <div class="search-content">
            <el-row :gutter="20">
              <el-col :sm="4">
                <el-input
                  v-model="listParkingSpaceInfo.conditions.areaNum"
                  placeholder="请输入停车场编号"
                ></el-input>
              </el-col>
              <el-col :sm="2">
                <el-button type="primary" @click="openChooseParkingArea">
                  <i class="el-icon-search"></i>
                  选择
                </el-button>
              </el-col>
              <el-col :sm="4">
                <el-input
                  v-model.trim="listParkingSpaceInfo.num"
                  placeholder="请输入车位编号"
                ></el-input>
              </el-col>
              <el-col :sm="4">
                <el-select
                  v-model="listParkingSpaceInfo.conditions.state"
                  placeholder="请选择车位状态"
                  style="width: 100%"
                >
                  <el-option value="" label="请选择车位状态"></el-option>
                  <el-option value="S" label="待售"></el-option>
                  <el-option value="H" label="待租"></el-option>
                  <el-option value="L" label="租赁中"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="6">
                <el-button type="primary" @click="queryParkingSpaceMethod">
                  <i class="el-icon-search"></i>
                  查询
                </el-button>
                <el-button @click="resetParkingSpaceMethod">
                  <i class="el-icon-refresh"></i>
                  重置
                </el-button>
              </el-col>
            </el-row>

            <el-row
              v-show="listParkingSpaceInfo.moreCondition"
              :gutter="20"
              style="margin-top: 15px"
            >
              <el-col :sm="6">
                <el-input
                  v-model.trim="listParkingSpaceInfo.conditions.psId"
                  placeholder="请输入车位ID"
                ></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>车位历史合同信息</span>
            <div style="float: right">
              <!-- 仅保留查看历史合同按钮 -->
            </div>
          </div>

          <el-table
            :data="listParkingSpaceInfo.parkingSpaces"
            border
            style="width: 100%"
            v-loading="loading"
            row-key="psId"
          >
            <el-table-column
              prop="areaNum"
              label="停车场"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="车位编号"
              align="center"
            ></el-table-column>
            <el-table-column label="车位状态" align="center">
              <template slot-scope="scope">
                {{ viewParkingSpaceState(scope.row.state) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="area"
              label="面积"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="contractId"
              label="合同编号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="leaseStartTime"
              label="租赁开始时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="leaseEndTime"
              label="租赁结束时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
            ></el-table-column>
            <el-table-column prop="leaseType" label="租赁方式" align="center">
              <template slot-scope="scope">
                {{ viewLeaseType(scope.row.leaseType) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="lesseeName"
              label="承租方"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="parkingSpaceCount"
              label="车位数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="carNumber"
              label="车牌号"
              align="center"
            ></el-table-column>
            <el-table-column label="总费用" align="center">
              <template slot-scope="scope">
                {{ chineseToNumber(scope.row.totalFeeCn) || 0 }}
              </template>
            </el-table-column>

            <!-- 印花税展示，只读 -->
            <el-table-column label="是否开具印花税" align="center" width="200">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.stampDutyStatus"
                  active-value="1"
                  inactive-value="0"
                  active-text="已开具"
                  inactive-text="未开具"
                  disabled
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="120">
              <template slot-scope="scope">
                <el-button-group>
                  <!-- 仅保留查看合同按钮，原修改合同弹窗改为只读查看 -->
                  <el-button
                    size="mini"
                    type="warning"
                    @click="openViewContractModal(scope.row)"
                    v-if="scope.row.contractId"
                  >
                    查看合同
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="listParkingSpaceInfo.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listParkingSpaceInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listParkingSpaceInfo.total"
            style="margin-top: 20px; text-align: right"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!-- 查看历史合同弹窗（全部禁用，只读） -->
    <el-dialog
      title="查看车位历史租赁合同"
      :visible.sync="viewContractModalVisible"
      width="700px"
      :close-on-click-modal="false"
      @close="handleViewContractClose"
    >
      <el-form
        ref="viewContractForm"
        :model="viewContractForm"
        label-width="120px"
        label-position="right"
        class="text-left"
      >
        <el-form-item label="合同ID">
          <el-input v-model="viewContractForm.contractId" disabled></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="承租方名称">
              <el-input
                v-model.trim="viewContractForm.lesseeName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="联系人">
              <el-input
                v-model.trim="viewContractForm.contactPerson"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="联系电话">
              <el-input
                v-model.trim="viewContractForm.contactPhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="车牌号">
              <el-input
                v-model.trim="viewContractForm.carNumber"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="车辆型号及颜色">
              <el-input
                v-model.trim="viewContractForm.carModelColor"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="租赁方式">
              <el-select
                v-model="viewContractForm.leaseType"
                disabled
                style="width: 100%"
              >
                <el-option label="月租" value="moom"></el-option>
                <el-option label="季度租" value="quarter"></el-option>
                <el-option label="半年租" value="halfYear"></el-option>
                <el-option label="年租" value="year"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="租赁开始时间">
              <el-date-picker
                v-model="viewContractForm.leaseStartTime"
                type="date"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="租赁结束时间">
              <el-date-picker
                v-model="viewContractForm.leaseEndTime"
                type="date"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="车位数">
              <el-input
                v-model.number="viewContractForm.parkingSpaceCount"
                type="number"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="总费用（大写）">
              <el-input
                v-model.trim="viewContractForm.totalFeeCn"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="车位类型">
              <el-select
                v-model="viewContractForm.parkingType"
                disabled
                style="width: 100%"
              >
                <el-option label="地下车位" value="underground"></el-option>
                <el-option label="地上车位" value="ground"></el-option>
                <el-option label="机械车位" value="mechanical"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="邮寄地址">
              <el-input
                v-model.trim="viewContractForm.mailingAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="电子邮箱">
              <el-input
                v-model.trim="viewContractForm.email"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="12">
            <el-form-item label="是否开票">
              <el-select
                v-model="viewContractForm.needInvoice"
                disabled
                style="width: 100%"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="viewContractModalVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 停车场选择弹窗 -->
    <choose-parking-area
      ref="chooseParkingArea"
      @choose="handleChooseParkingArea"
    />
  </div>
</template>

<script>
import {
  listParkingHistoryContract, // 替换为你的历史合同查询接口
  listParkingAreas,
  ListParkingContractInfo,
} from "@/api/car/listParkingSpaceApi";
import { getCommunityId } from "@/api/community/communityApi";
import ChooseParkingArea from "@/components/car/chooseParkingArea";
export default {
  name: "ListParkingHistoryContract",
  components: {
    ChooseParkingArea,
  },
  data() {
    return {
      loading: false,
      parkingAreaList: [],
      listParkingSpaceInfo: {
        parkingSpaces: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        num: "",
        moreCondition: false,
        conditions: {
          psId: "",
          area: "",
          paId: "",
          areaNum: "",
          state: "",
        },
      },
      viewContractModalVisible: false,
      currentParkingSpace: null,
      viewContractForm: {
        contractId: "",
        lesseeName: "",
        contactPerson: "",
        contactPhone: "",
        carNumber: "",
        carModelColor: "",
        leaseType: "",
        leaseStartTime: "",
        leaseEndTime: "",
        parkingSpaceCount: 1,
        totalFeeCn: "",
        parkingType: "",
        mailingAddress: "",
        email: "",
        communityId: "",
        psId: "",
        needInvoice: "",
      },
    };
  },
  created() {
    this.loadHistoryContractData();
    this.loadParkingAreaList();
  },
  methods: {
    // 加载车位+全部历史合同数据
    async loadHistoryContractData() {
      try {
        this.loading = true;
        const params = {
          page: this.listParkingSpaceInfo.currentPage,
          row: this.listParkingSpaceInfo.pageSize,
          communityId: getCommunityId(),
          num: this.listParkingSpaceInfo.num,
          psId: this.listParkingSpaceInfo.conditions.psId,
          area: this.listParkingSpaceInfo.conditions.area,
          paId: this.listParkingSpaceInfo.conditions.paId,
          state: this.listParkingSpaceInfo.conditions.state,
        };

        // 历史合同专属接口
        const res = await listParkingHistoryContract(params);
        this.listParkingSpaceInfo.parkingSpaces = res.parkingSpaces || [];
        this.listParkingSpaceInfo.total = res.total || 0;
      } catch (error) {
        this.$message.error(error.message || "历史合同数据加载失败");
      } finally {
        this.loading = false;
      }
    },

    async loadParkingAreaList() {
      try {
        const res = await listParkingAreas({
          communityId: getCommunityId(),
          page: 1,
          row: 100,
        });
        this.parkingAreaList = res.parkingAreas || [];
      } catch (error) {
        console.error("加载停车场列表失败:", error);
        this.$message.error("加载停车场列表失败");
      }
    },

    viewParkingSpaceState(state) {
      const stateMap = {
        S: "待售",
        H: "待租",
        L: "租赁中",
      };
      return stateMap[state] || "未知";
    },

    toggleMoreCondition() {
      this.listParkingSpaceInfo.moreCondition =
        !this.listParkingSpaceInfo.moreCondition;
    },

    queryParkingSpaceMethod() {
      this.listParkingSpaceInfo.currentPage = 1;
      this.loadHistoryContractData();
    },

    resetParkingSpaceMethod() {
      this.listParkingSpaceInfo.conditions = {
        psId: "",
        area: "",
        paId: "",
        areaNum: "",
        state: "",
      };
      this.listParkingSpaceInfo.num = "";
      this.queryParkingSpaceMethod();
    },

    openChooseParkingArea() {
      this.$refs.chooseParkingArea.open();
    },

    // 查看历史合同弹窗（只读）
    async openViewContractModal(row) {
      try {
        this.currentParkingSpace = row;
        const res = await ListParkingContractInfo({
          parkingSpaceId: row.psId,
          communityId: getCommunityId(),
        });
        if (res.code !== 0 || !res.data) {
          this.$message.error(res.msg || "查询合同详情失败");
          return;
        }
        this.viewContractModalVisible = true;
        this.$nextTick(() => {
          if (this.$refs.viewContractForm) {
            this.$refs.viewContractForm.resetFields();
          }
          this.viewContractForm = {
            ...res.data,
            needInvoice: res.data.needInvoice + "",
            communityId: getCommunityId(),
            psId: row.psId,
          };
        });
      } catch (error) {
        this.$message.error(error.message || "查询合同详情失败");
        console.error("查询合同详情失败:", error);
      }
    },

    handleViewContractClose() {
      this.currentParkingSpace = null;
      if (this.$refs.viewContractForm) {
        this.$refs.viewContractForm.resetFields();
      }
    },

    chineseToNumber(chinese) {
      if (!chinese) return 0;
      const numMap = {
        零: 0,
        壹: 1,
        贰: 2,
        叁: 3,
        肆: 4,
        伍: 5,
        陆: 6,
        柒: 7,
        捌: 8,
        玖: 9,
      };
      const unitMap = {
        拾: 10,
        佰: 100,
        仟: 1000,
        万: 10000,
        亿: 100000000,
      };

      let result = 0;
      let temp = 0;
      let unit = 1;

      for (let i = chinese.length - 1; i >= 0; i--) {
        const char = chinese[i];
        if (numMap[char] !== undefined) {
          temp = numMap[char] * unit;
          result += temp;
        } else if (unitMap[char]) {
          unit = unitMap[char];
        }
      }
      return result;
    },

    handleChooseParkingArea(parkingArea) {
      this.listParkingSpaceInfo.conditions.paId = parkingArea.paId;
      this.listParkingSpaceInfo.conditions.areaNum = parkingArea.num;
    },

    handlePageChange(page) {
      this.listParkingSpaceInfo.currentPage = page;
      this.loadHistoryContractData();
    },

    handleSizeChange(size) {
      this.listParkingSpaceInfo.pageSize = size;
      this.loadHistoryContractData();
    },

    viewLeaseType(type) {
      const typeMap = {
        moom: "月租",
        quarter: "季度租",
        halfYear: "半年租",
        year: "年租",
      };
      return typeMap[type] || "";
    },
  },
};
</script>

<style scoped>
.parking-history-contract-container {
  padding: 20px;
}

.search-content {
  padding: 10px 0;
}

.ibox-tools {
  display: inline-block;
  float: right;
  margin-top: 0;
  position: relative;
  padding: 0;
}

.text-left {
  text-align: left;
}

.dialog-footer {
  text-align: right;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
}
::v-deep .el-table td {
  vertical-align: middle;
}
</style>
